import fetch from "auth/FetchInterceptor";

const QuizService = {};

const quizPrefix = "/quizzes";

QuizService.getQuizzes = async () =>
  await fetch(`${quizPrefix}`, {
    method: "GET",
  });

QuizService.getQuiz = async (id) =>
  await fetch(`${quizPrefix}/${id}`, {
    method: "GET",
  });

QuizService.createQuiz = async (data) =>
  await fetch(`${quizPrefix}`, {
    method: "POST",
    data,
  });

QuizService.updateQuiz = async (id, data) =>
  await fetch(`${quizPrefix}/${id}`, {
    method: "PATCH",
    data,
  });

QuizService.deleteQuiz = async (id) =>
  await fetch(`${quizPrefix}/${id}`, {
    method: "DELETE",
  });

export default QuizService;
